export default "__VITE_ASSET__Bk8QeAXT__"